import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Composes class names; later Tailwind utilities override earlier ones. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
